let uat_base_url = {
  TEST_PLAYER_RESULT_JWT_TOKEN: "scholarship-website_R4tOTJq72gwx2Rex",
  TOKEN_API:
    "https://testplayerapi-qa.aakash.ac.in/stage/test_player/websiteToken",
  RESULT_API:
    "https://testplayerapi-qa.aakash.ac.in/stage/test_player/anthe-result?rollNo=",
  GET_PSID: "https://antheapi-qa.aakash.ac.in/api/get-user-psid?",
  GET_BRANCH_DETAIL: "https://antheapi-qa.aakash.ac.in/api/get-center-details?",
  PDF_UPLOAD_API: "https://antheapi-qa.aakash.ac.in/api/s3_upload_result",
  YEAR: new Date().getFullYear(),
  VALIDTILL: "31st December ",
  VERSION: "2.0",
  IACST_API:
    "https://testplayerapi-qa.aakash.ac.in/stage/test_player/iacst-result?rollNo=",
};

let production_base_url = {
  TEST_PLAYER_RESULT_JWT_TOKEN: "scholarship-website_WXD3ZnuMa5k4IEE4",
  TOKEN_API:
    "https://testplayerapi-prod.aakash.ac.in/Prod/test_player/websiteToken",
  RESULT_API:
    "https://testplayerapi-prod.aakash.ac.in/Prod/test_player/anthe-result?rollNo=",
  GET_PSID: "https://antheapi.aakash.ac.in/api/get-user-psid?",
  GET_BRANCH_DETAIL: "https://antheapi.aakash.ac.in/api/get-center-details?",
  PDF_UPLOAD_API: "https://antheapi.aakash.ac.in/api/s3_upload_result",
  YEAR: new Date().getFullYear(),
  VALIDTILL: "31st December ",
  VERSION: "2.0",
  IACST_API:
    "https://testplayerapi-prod.aakash.ac.in/Prod/test_player/iacst-result?rollNo=",
};
let localhost_base_url = {
  TOKEN_API:
    "https://testplayerapi-qa.aakash.ac.in/stage/test_player/websiteToken",
  RESULT_API:
    "https://testplayerapi-qa.aakash.ac.in/stage/test_player/anthe-result?rollNo=",
  GET_PSID: "https://antheapi-qa.aakash.ac.in/api/get-user-psid?",
  GET_BRANCH_DETAIL: "https://antheapi-qa.aakash.ac.in/api/get-center-details?",
  PDF_UPLOAD_API: "https://antheapi-qa.aakash.ac.in/api/s3_upload_result",
  TEST_PLAYER_RESULT_JWT_TOKEN: "scholarship-website_R4tOTJq72gwx2Rex",
  YEAR: new Date().getFullYear(),
  VALIDTILL: "31st December ",
  VERSION: "2.0",
  IACST_API:
    "https://testplayerapi-qa.aakash.ac.in/stage/test_player/iacst-result?rollNo=",
};
let config = {};

//if (process.env.REACT_APP_ENVIRONMENT === "production") {
  config = production_base_url;
//} else if (process.env.REACT_APP_ENVIRONMENT === "uat") {
//  config = uat_base_url;
//} else {
//  config = localhost_base_url;
//}

export default config;
